<template>
    <div class="container-parent">
        <div class="container-detail">
            <div class="mb-5">
                <h2 style="margin-bottom: 5px;">{{ title }}</h2>
                <span>Lengkapi data diri HiColers dan siap <i style="color: #162CA2;font-weight: 400;">#MulaiLangkahHebat</i> dari sekarang!</span>
            </div>

            <div class="mt-5" style="" v-if="!isSyllabus">
                <div class="label-field"><span>Batch Pelatihan</span></div>
                <v-autocomplete ref="schedule" v-model="schedule" :items="schedules" item-text="date" item-value="date"
                :placeholder="$t('checkout.form.selectPlaceholder')" required outlined dense class="mt-1 rounded-lg" 
                :error-messages="scheduleErrors" @input="selectSchedule" @blur="$v.schedule.$touch()"></v-autocomplete>
            </div>

            <v-divider class="mb-5"></v-divider>

            <div class="mt-3 mb-3">
                <span style="font-weight: 600;font-size: 18px;">Informasi Data diri</span>
                <div class="d-flex justify-space-between align-center mt-2">
                    <div style="width: 47%;">
                        <div class="label-field"><span>{{ $t('checkout.form.fullNameLabel') }}</span></div>
                        <v-text-field v-model="fullName" outlined dense required class="mt-2 rounded-lg"
                        :error-messages="fullNameErrors" @input="$v.fullName.$touch()"
                        @blur="$v.fullName.$touch()" ></v-text-field>
                    </div>

                    <div style="width: 47%;">
                        <div class="label-field"><span>Jenis Kelamin</span></div>
                        <v-autocomplete ref="gender" v-model="gender" :items="genders"
                            :placeholder="$t('checkout.form.selectPlaceholder')" required outlined dense class="mt-1 rounded-lg" 
                            :error-messages="genderErrors" @input="selectGender" @blur="$v.gender.$touch()"></v-autocomplete>
                    </div>
                </div>

                <div class="d-flex justify-space-between align-center mt-2">
                    <div style="width: 47%;">
                        <div class="label-field"><span>{{ $t('checkout.form.emailLabel') }}</span></div>
                        <v-text-field v-model="email" @keydown.space.prevent outlined dense required class="mt-2 rounded-lg"
                            :error-messages="emailErrors" @input="$v.email.$touch()" @blur="$v.email.$touch()"></v-text-field>
                    </div>

                    <div style="width: 47%;">
                        <div class="label-field"><span>{{ $t('checkout.form.phoneNumberLabel') }}</span></div>
                        <v-text-field v-model="phoneNumber" outlined dense required type="number" class="mt-2 rounded-lg"
                            :error-messages="phoneNumberErrors" @input="$v.phoneNumber.$touch()"
                            @blur="$v.phoneNumber.$touch()"></v-text-field>
                    </div>
                </div>

                <div class="mt-2">
                    <div class="label-field"><span>Instansi/Perusahaan</span></div>
                    <v-text-field v-model="companyName" outlined dense required class="mt-2 rounded-lg"
                        :error-messages="companyNameErrors" @input="$v.companyName.$touch()"
                        @blur="$v.companyName.$touch()"></v-text-field>
                </div>
                
            </div>

            <v-divider class="mt-3 mb-3"></v-divider>

            <div>
                <span style="font-weight: 600;font-size: 18px;">Lainnya</span>
                <div class="d-flex justify-space-between align-center mt-2">
                    <div style="width: 47%;">
                        <div class="label-field"><span>Darimana Mengetahui Program Ini?</span></div>
                        <v-autocomplete ref="sourceData" v-model="sourceData" :items="sourceDatas"
                            :placeholder="$t('checkout.form.selectPlaceholder')" required outlined dense class="mt-1 rounded-lg" 
                            :error-messages="sourceDataErrors" @input="selectSourceData" @blur="$v.sourceData.$touch()"></v-autocomplete>
                    </div>

                    <div style="width: 47%;">
                        <div class="label-field"><span>Motivasimu Mengikuti Pelatihan Ini?</span></div>
                        <v-autocomplete ref="motivation" v-model="motivation" :items="motivations"
                            :placeholder="$t('checkout.form.selectPlaceholder')" required outlined dense class="mt-1 rounded-lg" 
                            :error-messages="motivationErrors" @input="selectMotivation" @blur="$v.motivation.$touch()"></v-autocomplete>
                    </div>
                </div>
            </div>

            <v-divider class="mt-3 mb-3"></v-divider>

            <div class="mt-5" v-if="!isSyllabus">
                <div class="label-field"><span>Kode Voucher</span></div>
                <v-text-field v-model="voucherCode" outlined dense required class="mt-2 rounded-lg" @input="$v.voucherCode.$touch()"
                    @blur="$v.voucherCode.$touch()"></v-text-field>
            </div>

            <div class="d-flex align-center">
                <v-checkbox v-model="is_concent">
                  <template v-slot:label>
                    <div style="font-size: 12px;">
                        <span class="font-poppins">Dengan mengisi formulir ini, saya menyetujui <span class="font-poppins" style="cursor:pointer;color:#162CA2;font-weight: 600;"
                        @click="goToTermCondition">Syarat & Ketentuan</span> dan <span class="font-poppins" style="cursor:pointer;color:#162CA2;font-weight: 600;" @click="goToPrivacyPolicy">Kebijakan Privasi</span> untuk mengikuti program yang saya daftarkan.</span>
                    </div>
                  </template>
                </v-checkbox>
            </div>

            <div class="mt-3 mb-5" style="text-align: right;">
                <div>
                    <v-btn :class="`${validationRequired ? 'btn-terapkan' : 'btn-terapkan-disabled'} font-weight-bold pa-5`" width="40%" :loading="isLoading" :disabled="isLoading" @click.prevent="submitAction">
                        {{ buttonAction }}
                    </v-btn>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    fullName: { required },
    phoneNumber: { required },
    schedule: { required },
    gender: { required },
    email: { required, email },
    companyName: { required },
    motivation: { required },
    sourceData: { required }
  },
  data() {
    return {
      title: "Form Pendaftaran",
      is_concent: false,
      isLoading: false,
      isDetail: true,
      learningDisabled: false,
      imageURL: "",
      notes: "",
      className: "",
      classID: 0,
      hour: "",
      level: "",
      session: 0,
      totalPrice: 0,
      price: 0,
      discountPrice: 0,
      privateClassPrice: 0,
      privateDiscountPrice: 0,
      isPrivateClass: false,
      isVoucherValid: false,
      messageErrorReedemVoucher: "",
      isVoucherApplied: false,
      voucherPrice: 0,
      voucherCode: "",
      days: "",
      methode: "",
      mobileView: false,
      schedule: "",
      fullName: "",
      phoneNumber: "",
      companyName: "",
      email: "",
      motivation: "",
      motivations: ["Switch Career", "Pengembangan Skill", "Motivasi Lainnya"],
      sourceData: "",
      sourceDatas: ["Linkedin", "Instagram", "Google", "Tiktok", "Banner Hicolleagues Website", "Kerabat"],
      gender: "",
      genders: ["Laki-laki", "Perempuan"],
      birthdate: "",
      isDoubleClick: false,
      modal: false,
      schedules: [],
      voucher: {},
      categoryID: 0,
      isAlertErr: false,
      alertErrMessage: "",
      isSyllabus: false,
      buttonAction: 'Daftar',
    };
  },
  watch: {
    isAlertErr() {
      if (!this.isAlertErr) return;
      setTimeout(() => {
        this.isAlertErr = false;
      }, 3000);
    },
    email() {
      this.email = this.email.replace(" ", "");
    },
  },
  components: {
    // PopupError,
  },
  computed: {
    fullNameErrors() {
      const errors = [];
      if (!this.$v.fullName.$dirty) return errors;
      !this.$v.fullName.required &&
        errors.push("Nama lengkap tidak boleh kosong.");
      return errors;
    },
    companyNameErrors() {
      const errors = [];
      if (!this.$v.companyName.$dirty) return errors;
      !this.$v.companyName.required &&
        errors.push("Instansi/perusahaan tidak boleh kosong.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid email");
      !this.$v.email.required && errors.push("Email tidak boleh kosong");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.phoneNumber.$dirty) return errors;
      !this.$v.phoneNumber.required &&
        errors.push("Nomor telepon tidak boleh kosong.");
      return errors;
    },
    genderErrors() {
      const errors = [];
      if (!this.$v.gender.$dirty) return errors;
      !this.$v.gender.required && errors.push("Jenis kelamin tidak boleh kosong");
      return errors;
    },
    scheduleErrors() {
      const errors = [];
      if (!this.$v.schedule.$dirty) return errors;
      !this.$v.schedule.required && errors.push('Jadwal tidak boleh kosong');
      return errors;
    },
    motivationErrors() {
      const errors = [];
      if (!this.$v.motivation.$dirty) return errors;
      !this.$v.motivation.required && errors.push('Motivasi tidak boleh kosong');
      return errors;
    },
    sourceDataErrors() {
      const errors = [];
      if (!this.$v.sourceData.$dirty) return errors;
      !this.$v.sourceData.required && errors.push('Jadwal tidak boleh kosong');
      return errors;
    },
    validationRequired() {
        if(this.$route.query.p == 'syllabus'){
            if (this.gender != "" && this.phoneNumber != "" && this.email != "" && this.companyName != "" && this.fullName != "" && this.sourceData != "" && this.motivation != "" && this.is_concent) {
                return true;
            } else {
                return false;
            }
        } else {
            if (this.schedule != "" && this.gender != "" && this.phoneNumber != "" && this.email != "" && this.companyName != "" && this.fullName != "" && this.sourceData != "" && this.motivation != "" && this.is_concent) {
                return true;
            } else {
                return false;
            }
        }
    },
  },
  methods: {
    goToPrivacyPolicy() {
        window.location.href = '/privacy-policy';
    },
    goToTermCondition() {
        window.location.href = '/term-condition';
    },
    handleView() {
      this.mobileView = window.innerWidth <= 990;
    },
    backToPreviousPage() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Go Back - Checkout Page',
        value: 1,
      });
      history.go(-1);
    },
    toggleDetails() {
      this.isDetail = !this.isDetail;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle Class Details - ${this.className} - Checkout Page`,
        value: 1,
      });
    },
    selectSchedule() {
      this.$v.schedule.$touch();
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Select Schedule - ${this.schedule} - Checkout Page`,
        value: 1,
      });
    },
    selectGender() {
      this.$v.gender.$touch();
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Select Gender - ${this.gender} - Checkout Page`,
        value: 1,
      });
    },
    selectSourceData() {
      this.$v.sourceData.$touch();
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Select Source Data - ${this.sourceData} - Checkout Page`,
        value: 1,
      });
    },
    selectMotivation() {
      this.$v.motivation.$touch();
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Select Motivation - ${this.motivation} - Checkout Page`,
        value: 1,
      });
    },
    clearVoucher() {
      this.voucherCode = '';
      this.isVoucherApplied = false;
      this.isVoucherValid = false;
      this.voucherPrice = 0;
      this.messageErrorReedemVoucher = '';
      this.getTotalPrice();
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: 'Clear Voucher - Checkout Page',
        value: 1,
      });
    },
    getTotalPrice() {
      if (this.$route.query.category === 'PUBLIC_TRAINING') {
        if (this.isPrivateClass) {
          this.totalPrice = this.privateClassPrice - this.voucherPrice;
        } else {
          this.totalPrice = this.price - this.voucherPrice;
        }
      } else {
        this.totalPrice = this.price + this.privateClassPrice - this.voucherPrice;
      }
    },
    getLocalDb() {
      var data = JSON.parse(localStorage.getItem("checkout"));
      this.price = data.price;
      this.classID = data.class_id;
      this.className = data.class_name;
      this.hour = data.hour;
      this.level = data.level;
      this.session = data.session;
      this.methode = data.methode;
      this.days = data.days;
      this.imageURL = data.image_url;
      this.classType = data.class_type;
      this.categoryID = data.category_id;
    },
    async getPayment() {
      this.$v.$touch();
      this.isLoading = true;
      if (this.phoneNumber.length < 10) {
        this.isLoading = false;
        this.isAlertErr = true;
        this.alertErrMessage = "Nomor telepon tidak valid";
        this.$gtag.event('click', {
          event_category: 'Interaction',
          event_label: 'Submit Payment Failed - Invalid Phone Number - Checkout Page',
          value: 1,
        });
        return;
      }
    //   if (this.voucherCode) {
    //     const confirmVoucher = await this.applyVoucherCode();
    //     if (!confirmVoucher) {
    //       this.isLoading = false;
    //       this.$gtag.event('click', {
    //         event_category: 'Interaction',
    //         event_label: `Apply Voucher Failed - ${this.voucherCode} - Checkout Page`,
    //         value: 1,
    //       });
    //       return;
    //     }
    //   }
        if (!this.$v.$error) {
            if (this.isDoubleClick) {
            setTimeout(() => {
                this.isDoubleClick = false;
            }, 1000);
            this.isLoading = false;
            return;
            }
            // const [startInput, endInput] = this.schedule.split(" - ");
            // const startISO = moment.utc(startInput, "DD MMM YYYY").toISOString().replace(".000", "");
            // const endISO = moment.utc(endInput, "DD MMM YYYY").toISOString().replace(".000", "");
            // const result = this.schedules.find(item => item.start_date === startISO && item.end_date === endISO) || { batch_number: 0 };
            this.isDoubleClick = true;
            this.$gtag.event('click', {
            event_category: 'Interaction',
            event_label: `Submit Payment - ${this.className} - Checkout Page`,
            value: 1,
            });
            await this.$http
            .post("/v1/transaction-bootcamp", {
                class_id: this.classID,
                schedule: this.schedule,
                full_name: this.fullName,
                phone_number: this.phoneNumber,
                email: this.email,
                gender: this.gender,
                corporate_name: this.companyName,
                source_data: this.sourceData,
                motivation_note: this.motivation,
                voucher_code: this.voucherCode,
                batch: this.schedules[0].batch_number,
                price: 100000,
                status: "WAITING_FOR_PAYMENT",
            })
            .then((response) => {
                this.isLoading = false;
                window.open(response.data.data.transaction.url, '_self');
            })
            .catch((err) => {
                console.error(err.response);
                this.isLoading = false;
                this.$gtag.event('click', {
                event_category: 'Interaction',
                event_label: `Submit Payment Error - ${this.className} - Checkout Page`,
                value: 1,
                });
            });
        }
    },
    async getSyllabus() {
        await this.$http.post('/v1/lead', {
            name: this.fullName,
            email: this.email,
            phone_number: this.phoneNumber,
            company: this.companyName,
            gender: this.gender,
            product_need: "minta silabus",
            source: this.sourceData,
            segment: "warm lead",
            note: this.motivation
        }).then(() => {
            this.$router.push("/success-request-syllabus");
        })
    },
    submitAction() {
        if(this.$route.query.p == 'syllabus') {
            this.getSyllabus();
        } else {
            this.getPayment();
        }
    },
    // async applyVoucherCode() {
    //   this.messageErrorReedemVoucher = "";
    //   this.$gtag.event('click', {
    //     event_category: 'Interaction',
    //     event_label: `Apply Voucher - ${this.voucherCode} - Checkout Page`,
    //     value: 1,
    //   });
    //   try {
    //     const response = await this.$http.get(
    //       `/v2/voucher/${this.voucherCode}?category_code=GENERAL&class_category_id=${this.categoryID}&class_id=${this.classID}`
    //     );
    //     this.voucher = response.data.data.voucher;
    //     this.voucherPrice = this.voucher.discount;
    //     this.isVoucherApplied = true;
    //     this.isVoucherValid = true;
    //     this.getTotalPrice();
    //     return true;
    //   } catch {
    //     this.isVoucherValid = false;
    //     this.isVoucherApplied = false;
    //     this.messageErrorReedemVoucher = "Voucher tidak valid";
    //     this.$gtag.event('click', {
    //       event_category: 'Interaction',
    //       event_label: `Apply Voucher Failed - ${this.voucherCode} - Checkout Page`,
    //       value: 1,
    //     });
    //     return false;
    //   }
    // },
    async getSchedule() {
      try {
        const response = await this.$http.get(`/v1/schedule/class/${this.classID}`);
        response.data.data.schedules.forEach((element) => {
          this.schedules.push({
            ...element,
            date:
              this.format_date(element.start_date) +
              " - " +
              this.format_date(element.end_date),
          });
        });
      } catch (err) {
        console.error(err.response);
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).utc().format("DD MMM YYYY");
      }
    },
    privacyPolicy() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Go to Privacy Policy - Checkout Page',
        value: 1,
      });
      this.$router.push("/privacy-policy");
    },
    termCondition() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Go to Terms and Conditions - Checkout Page',
        value: 1,
      });
      this.$router.push("/term-condition");
    },
  },
  mounted() {
    this.getLocalDb();
    this.handleView();
    this.getTotalPrice();
    this.getSchedule();
    this.$utils.scrollTop();
    this.$gtag.pageview(this.$route);
    if(this.$route.query.p == 'syllabus') {
        this.title = 'Silabus ' + this.className
        this.isSyllabus = true
        this.buttonAction = 'Minta Silabus'
    }
  },
};
</script>

<style scoped>
.container-parent {
    background-color: #F5F6F9;
    padding: 100px 0px;
    color: #575966;
}

.container-detail {
    display: block;
    margin-top: 50px;
    margin-left: auto;
    margin-right: auto;
    padding: 5px 30px;
    background-color: white;
    max-width: 680px;
    border-radius: 16px;
}

.label-field {
    font-size: 14px;
    font-weight: 600;
}

.btn-terapkan {
  width: 100%;
  color: #fff;
  border-radius: 8px;
  background-color: #000080 !important;
}

.btn-terapkan-disabled {
  width: 100%;
  color: #fff;
  border-radius: 8px;
  background-color: #ACAFBF !important;
}

@media screen and (max-width: 550px) {
  .container-parent{
    padding: 0 !important;
  }
}
</style>